var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('span',{staticClass:"icon-back",on:{"click":_vm.backClick}}),_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }